import React from 'react';

const ProgressBar = ({ progress = 0, label = '' }) => {
  return (
    <div className="w-full">
      {label && (
        <div className="mb-1 font-medium text-[#344E41] text-sm sm:text-base">{label}</div>
      )}
      <div className="w-full h-4 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-primary to-accent rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="mt-1 text-[#588157] font-medium text-xs sm:text-sm text-right">{progress}%</div>
    </div>
  );
};

export default ProgressBar; 